import type { DocumentPreviewResponse } from './types'

// Flattens a `#preview` response into the URL list PDFTron's `initialDocs` prop
// expects (see `types.ts` for the tabs-vs-url shape).
export function documentPreviewToDocs(
  response: DocumentPreviewResponse | null | undefined
): string[] {
  if (!response) return []
  if (response.tabs && response.tabs.length > 0) {
    return response.tabs.map((tab) => tab.url)
  }
  return response.url ? [response.url] : []
}
